import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * When the user is already on the artist listing (`/` or `/artists`), Angular does not
 * re-navigate on repeated “Overview” clicks. Emit here so {@link ArtistRankingsComponent}
 * can restore default filters, sort, and drawer state.
 */
@Injectable({ providedIn: 'root' })
export class ArtistListingsUiService {
  private readonly resetSubject = new Subject<void>();
  readonly reset$ = this.resetSubject.asObservable();

  requestOverviewReset(): void {
    this.resetSubject.next();
  }
}
